//https://www.105.net/custom_widget/finelco/ws_apps_105/getProgrammaOnAir.jsp

export default function (data, limit = 3) {
    let result = [];
    let count = 0;

    if (data.onair && data.onair[0]) {
        let latestSongs = data.onair[0].latest_songs || [];
        let item;
        for (let i = 0; i < latestSongs.length; i++) {
            item = latestSongs[i];
            if (count >= limit) break;
            if (!item.copertina) continue;

            result.push({
                artist: item.artista,
                title: item.brano,
                artwork: item.copertina,
                datePlay: null
            });
            count++;
        }
    }

    return result;
}